import _request from '@/utils/request.js'

var _department = {
    // 查询部门信息（树形结构）
    getDepartmentTree (resolve, reject) {
        _request.api({
            url     : _request.getStaffsUrl("/api/department/getDepartmentTree"),
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
    // 查询部门信息（树形结构）
    getDepartmentTreeByDepartmentId (departmentId, resolve, reject) {
        _request.api({
            url     : _request.getStaffsUrl("/api/department/getDepartmentTreeByDepartmentId"),
            params  : {
                departmentId: departmentId
            },
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
    // 更新部门缓存
    updateCache (resolve, reject) {
        _request.api({
            url     : _request.getStaffsUrl("/api/department/updateCache"),
            method  : 'get',
            success : resolve,
            error   : reject
        })
    }
}

export default _department
